import React from "react";
import {
  MonitorSmartphone,
  Ticket,
  FolderKanban,
  HardDrive,
  TrendingUp,
  ArrowLeft,
  CheckCircle2,
} from "lucide-react";
import { Link } from "react-router-dom";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";

const ITServicesPage = () => {
  const features = [
    {
      icon: <Ticket size={26} />,
      title: "Ticket Management",
      description:
        "Track every support request from intake to resolution with clear ownership and priority levels.",
    },
    {
      icon: <FolderKanban size={26} />,
      title: "Project Tracking",
      description:
        "Manage internal IT projects, upgrades, and deployments with visual boards and progress tracking.",
    },
    {
      icon: <HardDrive size={26} />,
      title: "Hardware & Asset Tracking",
      description:
        "Keep tabs on every device, license, and asset across departments with automated inventory.",
    },
    {
      icon: <TrendingUp size={26} />,
      title: "Department Visibility",
      description:
        "Give stakeholders real-time visibility into IT operations, capacity, and service levels.",
    },
  ];

  const benefits = [
    "Reduce average ticket resolution time by 40%",
    "Centralize all IT operations in one platform",
    "Automate hardware procurement workflows",
    "Track SLA compliance across service categories",
    "Generate real-time reports for leadership",
  ];

  return (
    <>
      <HeaderMenu />
      <div className="IT_Service_main">
        {/* Navigation */}
        {/* <div className="IT_Service_nav">
        <div className="IT_Service_container">
          <Link to="/" className="IT_Service_back_link">
            <ArrowLeft size={18} />
            Back to About
          </Link>
        </div>
      </div> */}

        {/* Hero */}
        <section className="IT_Service_hero">
          <div className="IT_Service_container">
            <div className="IT_Service_hero_content">
              <div className="IT_Service_icon_box">
                <MonitorSmartphone size={34} />
              </div>

              <h1 className="IT_Service_heading">
                Workflow platform for IT service teams
              </h1>

              <p className="IT_Service_subheading">
                Track tickets, internal projects, and hardware deployments with
                clear visibility across the entire department.
              </p>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="IT_Service_features_section">
          <div className="IT_Service_container">
            <h2 className="IT_Service_section_title">
              Everything IT teams need in one platform
            </h2>

            <div className="IT_Service_features_grid">
              {features.map((feature, index) => (
                <div key={index} className="IT_Service_feature_card">
                  <div className="IT_Service_feature_icon">{feature.icon}</div>

                  <h3 className="IT_Service_feature_title">{feature.title}</h3>

                  <p className="IT_Service_feature_description">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="IT_Service_benefits_section">
          <div className="IT_Service_container">
            <div className="IT_Service_benefits_wrapper">
              <h2 className="IT_Service_section_title IT_Service_center">
                Why IT teams choose Simplifyte
              </h2>

              <div className="IT_Service_benefits_list">
                {benefits.map((benefit, index) => (
                  <div key={index} className="IT_Service_benefit_item">
                    <CheckCircle2 size={24} className="IT_Service_check_icon" />

                    <p>{benefit}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="IT_Service_cta_section">
          <div className="IT_Service_container">
            <div className="IT_Service_cta_box">
              <h2 className="IT_Service_cta_title">
                Ready to elevate your IT operations?
              </h2>

              <p className="IT_Service_cta_text">
                Join IT teams who've gained complete visibility and control over
                their service delivery.
              </p>

              <button
                className="IT_Service_cta_button"
                onClick={() =>
                  (window.location.href = "https://app.simplifyte.com")
                }
              >
                Start Free Trial
              </button>
            </div>
          </div>
        </section>
      </div>
      <CustomFooter />
    </>
  );
};

export default ITServicesPage;
